import Errors from "@shared/errors";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

let couponCart = window.localStorage.getItem("couponStore");
let couponApplied = window.localStorage.getItem("couponApplied");

const initialState = () => {
    return {
        couponStatus: "",
        couponCart: couponCart ? JSON.parse(couponCart) : {},
        couponApplied: couponApplied ? JSON.parse(couponApplied) : false,
        couponErrors: new Errors(),
        couponMessage: "",
        discountTotal: 0,
    };
};

const state = {
    initialState: initialState,
    ...initialState(),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
